import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-user-relationship',
    templateUrl: './user-relationship.component.html',
    styleUrls: ['./user-relationship.component.css']
})

export class UserRelationshipComponent implements OnInit {

    constructor(    
        public httpClient: HttpClient,
        ) { }
    
    status = 1; //正常
    status1 = 1; //正常
    target:any = {user_id:'',uid:'',phonenum:'',fixid:-1};
    search_model:string = '';
    target1:any = {user_id:'',uid:'',phonenum:'',fixid:-1};
    search_model1:string = '';
    loading:boolean=false;
    relationship = '';
    color = '';    

    ngOnInit(): void {}


    callitem(item){
        this.target = item;

        if(this.target.is_enable == 0){
            this.status = -1; //停權 
        }

        if(this.target.phone_num < 0){
            this.status = -2; //刪帳號 
        }  
    }

    searchstr(item){
        this.search_model = item;
        this.target.user_id = '';
        this.target.uid = '';
        this.relationship = '';
    }

    callitem1(item){
        this.target1 = item;  

        if(this.target1.is_enable == 0){
            this.status1 = -1; //停權 
        }

        if(this.target1.phone_num < 0){
            this.status1 = -2; //刪帳號 
        }    
    }

    searchstr1(item){
        this.search_model1 = item;
        this.target1.user_id = '';
        this.target1.uid = '';
        this.relationship = '';
    }

    checkUserStatus(){
        this.loading = true;

        if(this.target.user_id == ''){
            alert('請輸入當事人');
        }else if (this.target1.user_id == '') {
            alert('請輸入對象');
        }else{
            const body = {target:this.target,target1:this.target1};
            this.httpClient.post<any>("/checkUserRelationShip.php",body).subscribe(res => {
                this.loading = false;
                if(res.status){
                    switch (res.is_follow) {
                        case -3:
                            this.relationship = this.target1.name + ' 黑名單 ' + this.target.name;
                            this.color = '#3e62b1';
                        break;
                        case -6:
                            this.relationship =  this.target.name + ' 黑名單 ' + this.target1.name;
                            this.color = '#b13e62';
                        break;
                        case -9:
                            this.relationship = '相互封鎖';
                            this.color = '#b13e3e';
                        break;
                        case 0:
                            this.relationship = '沒有關係';
                            this.color = '#3eb1a9';
                        break;
                        case 2:
                            this.relationship = this.target1.name + ' 追蹤 ' + this.target.name + ',' + this.target.name + ' 黑名單 ' + this.target1.name;
                            this.color = '#3ea9b1';
                        break;
                        case 8:
                            this.relationship = this.target1.name + ' 追蹤 ' + this.target.name;
                            this.color = '#62b13e';
                        break;    
                        case 9:
                            this.relationship = this.target.name + ' 追蹤 ' + this.target1.name + ',' + this.target1.name + ' 黑名單 ' + this.target.name;
                            this.color = '#3eb162';
                        break;
                        case 12:
                            this.relationship = this.target.name + ' 追蹤 ' + this.target1.name;
                            this.color = '#a93eb1';
                        break;
                        case 20:
                            this.relationship = '相互追蹤';
                            this.color = '#b1a93e';
                        break;
                    default:
                        break;
                    }
                }
            });
        }
    }
}
